import axios from "axios";
import store from "@/store";

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth'
import Router from '../router/index'

const loginEvent = 'freshToken'


export default {
  async login2(payload) {
    await authClient.get("/sanctum/csrf-cookie");
    return authClient.post("/login", payload);
  },
  isUserLoggedIn() {
    let isAuthenticated = false

    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser

    if (firebaseCurrentUser) isAuthenticated = true
    else isAuthenticated = false

    // return localStorage.getItem(loginEvent) != "null";
    return localStorage.getItem(loginEvent) != null && localStorage.getItem(loginEvent) != 'null';
  },
  async login (payload) {
    // If user is already logged in notify and exit
    if (this.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        type: 'warning'
      })
      return false
    }
    // Try to sigin
    try {
      var result = await firebase.auth().signInWithEmailAndPassword(payload.email, payload.password);
      var token = await result.user.getIdToken(true);
      var response = await axios.post('/auth/loginViaToken', {
        'device_name': `${vm.$browserDetect.meta.name  }- v${  vm.$browserDetect.meta.version}`,
        token
      });
      const isAdmin = response.data.admin
      if (!isAdmin)
      {
        const error = Error(
          "Your account can not be used here! Only admin accounts."
        );
        error.name = "Not admin";
        throw error;
      }
      const ourToken = response.data.token
      const freshToken = ourToken.split('|')[1]
      localStorage.setItem(loginEvent, freshToken)
      axios.defaults.headers.common['Authorization'] = `Bearer ${freshToken}`
      const user = response.data.user || response.data.user_data;
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
        if (user.role !== undefined) {
          localStorage.setItem('user_role', user.role.toString());
        }
      }
      return true;
    } catch (error) {
      localStorage.setItem(loginEvent, null)
      localStorage.removeItem('user')
      localStorage.removeItem('user_role')
      payload.notify({
        title: 'Error',
        text: error.message,
        type: 'error'
      })
    }
  },
  async logout() {

    // if user is logged in via firebase
    const firebaseCurrentUser = firebase.auth().currentUser

    if (firebaseCurrentUser) {
      await firebase.auth().signOut();
    }

    localStorage.setItem(loginEvent, null)
    localStorage.removeItem('user')
    localStorage.removeItem('user_role')

    // If user clicks on logout -> redirect
    Router.push('/login').catch(() => {})
  },
  logout2() {
    return authClient.post("/logout");
  },
  async forgotPassword(payload) {
    await authClient.get("/sanctum/csrf-cookie");
    return authClient.post("/forgot-password", payload);
  },
  getAuthUser() {
    return authClient.get("/api/users/auth");
  },
  async resetPassword(payload) {
    return axios
    .post('/auth/reset-password', {
      email: payload.email,
    });
  },
  updatePassword(payload) {
    return authClient.put("/user/password", payload);
  },
  async registerUser(payload) {
    await authClient.get("/sanctum/csrf-cookie");
    return authClient.post("/register", payload);
  },
  sendVerification(payload) {
    return authClient.post("/email/verification-notification", payload);
  },
  updateUser(payload) {
    return authClient.put("/user/profile-information", payload);
  },
  checkError(error, router, swal)
  {
    console.log(error)
    if(typeof error === 'string' && error.includes('Unauthenticated'))
    {
      this.logout();
      router.push({ name: 'login' });
    }
    else{
      swal("Error", error, "error");
    }
  },
  getUserRole() {
    return getUserRole();
  },
  getCurrentUser() {
    return getCurrentUser();
  },
  getRoleLandingRoute(role) {
    return getRoleLandingRoute(role);
  }
};

export function getRoleLandingRoute(role) {
  const r = parseInt(role !== undefined && role !== null ? role : getUserRole(), 10);
  if (r === 4) return '/operations';
  if (r === 3) return '/routes';
  if (r === 5) return '/customer-service/tickets';
  return '/dashboard';
}

export function getCurrentUser() {
  if (typeof window !== 'undefined') {
    try {
      const u = localStorage.getItem('user');
      return u && u !== 'null' ? JSON.parse(u) : null;
    } catch (e) {
      return null;
    }
  }
  return null;
}

export function getUserRole() {
  if (typeof window !== 'undefined') {
    // Only resolve role for an authenticated session
    const token = localStorage.getItem('freshToken');
    if (!token || token === 'null') {
      return 0;
    }

    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user && user.role !== undefined && user.role !== null) {
        return parseInt(user.role, 10);
      }
    } catch (e) {}

    const storedRole = localStorage.getItem('user_role');
    if (storedRole !== null && storedRole !== undefined && storedRole !== 'null') {
      const parsed = parseInt(storedRole, 10);
      if (!isNaN(parsed)) return parsed;
    }
  }
  return 0; // Default: Super Admin (role 0)
}
